module.exports = __webpack_public_path__ + "static/media/icon-login-report-not-login.2246d5d5.svg";